export const PERMISSION_REASONS = Object.freeze({
  CONSENT_FORM: "consent_form",
  ENOTE: "enote",
  NOT_OWNER: "not_owner",
  PARTNER: "partner",
  COMPLETED: "completed",
});
